<template>
  <div class="seatsApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="选座加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div>
      <div class="cinemaTitle" @click="$router.go(-1)"><i class="el-icon-arrow-left"></i>{{setCinema.cinemaName}}</div>
      <div class="header">
        <div class="h">
          <div><span style="border-color:#E9145A;background:#E9145A"></span>已选</div>
          <div><span style="border-color:#FFB900;background:#FFB900"></span>已售</div>
          <div><span style="background:#eee"></span>不可售</div>
          <div v-for="(item,i) in setCinema.areaPriceList">
            <span :style="'border-color:'+item.color"></span>{{item.price/100}}元
          </div>
        </div>
      </div>
      <div class="wt">{{setCinema.hallName}}</div>
      <div class="seats-list" ref="seatWrap" :style="`zoom: ${zoom}`">
        <div class="bay-number">
          <div class="bay" v-for="(item,i) in setSeatsInfo" :key="i">{{i}}</div>
        </div>
        <div class="seatsAll">
          <ul>
            <li v-for="(item,i) in setSeatsInfo">
              <span :style="'border-color:'+vo.color" v-for="(vo,k) in item" :class="(vo.status == 1 ? '' : vo.status == 0 ? 'LK' : 'W') + (findVal(vo.seatid) ? ' choose' : '')"  @click="chooseSeats(vo.status,vo.seatid,vo.area,vo.name,findVal(vo.seatid))"></span>
            </li>
          </ul>
        </div>
      </div>
      <div class="showInfo">
        <h2>{{setCinema.movieName}}</h2>
        <p>{{(setCinema.playTime)}} 至 {{(setCinema.closeTime)}} {{setCinema.edition}}</p>
        <dl>
          <dd v-for="(item,i) in seatsXz">
            <span>{{item.name}}</span>
            <font>{{item.salePrice}}元</font>
            <i class="el-icon-close" @click="closeSeats(i)"></i>
          </dd>
        </dl>
      </div>
      <div class="btn" @click="saveCheck">{{price > 0 ? price+'元 ':''}}确认选座</div>
      <div style="height:30px"></div>

      <div class="txg">
        <p>温馨提示：选座时请注意规避以下几种情况</p>
        <p>1、单人选座，座位靠边不要留空位。</p>
        <p>2、单人选座，座位旁边不要留空位。</p>
        <p>3、多人选座，座位中间不要留空位。</p>
        <p>4、多人选座，座位靠边不要留空位。</p>
        <p>以上选座情况导致选座失败，出票不成功。如需退款，请联系客服：18580092850</p>
      </div>
    </div>
  </div>
  
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  const setGesture = (el, options = {}) => {
    var obj = {}; //定义一个对象
    var istouch = false;
    var start = [];
    var scale = 1;
    var absScale = 1;

    var minScale = options.minScale || 0.5;
    var maxScale = options.maxScale || 2;

    el.addEventListener(
      "touchstart",
      e => {
        if (e.touches.length >= 2) {
          scale = scale >= maxScale ? maxScale : scale;
          scale = scale <= minScale ? minScale : scale;
          absScale = scale;
          //判断是否有两个点在屏幕上
          istouch = true;
          start = e.touches; //得到第一组两个点
          obj.gesturestart && obj.gesturestart.call(el); //执行gesturestart方法
        }
      },
      false
    );
    document.addEventListener(
      "touchmove",
      e => {
        e.preventDefault();
        if (e.touches.length >= 2 && istouch) {
          var now = e.touches; //得到第二组两个点
          scale =
            absScale -
            (1 - getDistance(now[0], now[1]) / getDistance(start[0], start[1]));

          scale = scale >= maxScale ? maxScale : scale;
          scale = scale <= minScale ? minScale : scale;

          // scale =
          // +scale !== 1
          //   ? getDistance(now[0], now[1]) / getDistance(start[0], start[1])
          //   : scale; //得到缩放比例，getDistance是勾股定理的一个方法
          let position = {};
          var rotation = getAngle(now[0], now[1]) - getAngle(start[0], start[1]); //得到旋转角度，getAngle是得到夹角的一个方法
          position.scale = scale.toFixed(2);
          position.rotation = rotation.toFixed(2);
          obj.gesturemove && obj.gesturemove.call(el, position); //执行gesturemove方法
        }
      },
      false
    );
    document.addEventListener(
      "touchend",
      () => {
        if (istouch) {
          istouch = false;
          obj.gestureend && obj.gestureend.call(el); //执行gestureend方法
        }
      },
      false
    );
    return obj;
  };
  const getDistance = (p1, p2) => {
    var x = p2.pageX - p1.pageX,
      y = p2.pageY - p1.pageY;
    return Math.sqrt(x * x + y * y);
  };
  const getAngle = (p1, p2) => {
    var x = p1.pageX - p2.pageX,
      y = p1.pageY - p2.pageY;
    return (Math.atan2(y, x) * 180) / Math.PI;
  };
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        code:'',
        setCinema:[],
        boxGesture: null,
        zoom: 1,
        setShowInfo:[],
        setSeatsInfo:[],
        seatsXz:[],
        seatIdarr:[],
        price:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      var id = this.$route.query.id;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/seats?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }

    },
    mounted() {
      this.timestamp = Date.parse(new Date());
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
      }
        this.getSeats()
      this.beforeMount();
        //this.initGesture();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getLocalTime:function(nS) {
        var str = new Date(parseInt(nS)).toLocaleString();
        return str.substr(9, str.length - 12)    
      },
      getLocalTime1:function(nS) {
        var str = new Date(parseInt(nS)).toLocaleString('zh',{year: '2-digit',month: '2-digit',  day: '2-digit',  hour: '2-digit',  minute: '2-digit',  second: '2-digit'});
        return str.substr(3, str.length - 8)    
      },
      initGesture() {
        this.boxGesture = setGesture(this.$refs.seatWrap);

        this.boxGesture.gesturemove = e => {
          this.zoom = e.scale;
        };
      },
      getSeats:function(){
        var that = this;
        var showId = this.$route.query.id;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/seats',
          data:{
            showId:showId
          },
          dataType:'json',
          success:function(data){
            data.data.playItem.playTime = (data.data.playItem.playTime).substring(5,16);
            data.data.playItem.closeTime = (data.data.playItem.closeTime).substring(11,16);
            that.setCinema = data.data.playItem;
            //that.setShowInfo = data.data.showInfo;
            that.setSeatsInfo = data.data.rs.seatList;
            that.fullscreenLoading = false;
          }
        })
      },
      closeSeats:function(inx){
        this.price = (this.price - this.seatsXz[inx].salePrice).toFixed(1)
        this.seatsXz.splice(inx,1);
        this.seatIdarr.splice(inx,1);
      },
      chooseSeats:function(state,seatId,area,name,bool){
        if(state != 1){
          return false;
        }
        area = (area == null ? '' : area);
        var sections = this.setCinema.areaPriceList
        var arr = this.seatsXz;
        if(arr.length>=4){
          this.$alert('座位最多能选四个.', '提示');
          return false;
        }
        for(var i =0;i<sections.length;i++){
          if(area == sections[i].area){
            if(bool == false){
              arr.push({seatId:seatId,salePrice:(sections[i].price/100),name:name});
              this.price = (this.price*1 + (sections[i].price/100)).toFixed(1)
            }
            
          }
        }
        if(bool == false){
          this.seatIdarr.push(seatId);
        }
        this.seatsXz = arr;
      },
      findVal:function(val){
        var arr = this.seatIdarr;
        var bool = false;
        for(var i=0;i<arr.length;i++) {
          if(arr[i] == val) {
            bool = true
          }
        }
         return bool
      },
      saveCheck:function(){
        var that = this;
        let Base64 = require('js-base64').Base64;
        var showId = this.$route.query.id;
        var arr = [showId,that.seatsXz];
        var str = JSON.stringify(arr);
        that.$router.push({
          path:'moviesorder',
          query:{
            str:Base64.encode(str)
          }
        })
        /*that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/check',
          data:{
            showId:showId,
            seatIds:JSON.stringify(that.seatIdarr)
          },
          dataType:'json',
          success:function(data){
            if(data.data.errCode == 0){
              var arr = data.data.data;
              arr['showId'] = showId;
              arr['cinemaId'] = that.setCinema.cinemaId;
              arr['movieId'] = that.setShowInfo.movieId;
              arr['seatIds'] = that.seatIdarr;
              var str = JSON.stringify(arr);
              that.$router.push({
                path:'moviesorder',
                query:{
                  str:Base64.encode(str)
                }
              })
            }else{
              that.$alert(data.data.errMessage, '提示');
            }
            that.fullscreenLoading = false;
          }
        })*/
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .seatsApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .seatsApp .header{
    width:96%;
    margin:0 auto 20px auto;
    overflow: auto;
    scrollbar-width: none;
    height:20px;
  }
  .seatsApp .header .h{
    display:block;
    height:20px;
    width:460px
  }
  .seatsApp .cinemaTitle{
    width:96%;
    margin:0 auto;
    font-weight:bold;
    font-size:18px;
    padding:15px 0 20px 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .seatsApp .header .h div{
    height:18px;
    font-size:12px;
    line-height:20px;
    color:#333;
    float:left;
    margin-right:10px
  }
  .seatsApp .header div span{
    float:left;
    width:16px;
    height:16px;
    background:#fff;
    margin-right:3px;
    border-radius:7px;
    border:solid 1px #ccc
  }
  .seatsApp .wt{
    position: relative;
    text-align:center;
    padding:15px 0;
    color:#666
  }
  .seatsApp .wt:before{
    content:'';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 130px;
    height: 100px;
    background:radial-gradient( circle at 62px 160px, transparent 150px, #E9145A 151px, transparent 153px)
    
  }
  .seatsApp .seats-list{
    position: relative;
    min-height: 200px;
    box-sizing: border-box;
    margin-bottom:20px;
  }
  .seatsApp .seats-list  .bay-number {
    pointer-events: none;
    position: absolute;
    width: 22px;
    left: 10px;
    color: #fff;
    overflow: auto;
    line-height: 23px;
    scrollbar-width: none;
    z-index:9999
  }
  .seatsApp .seats-list .bay-number .bay {
    width: 22px;
    background-color: rgba(91, 91, 91, 0.35);
    height: 23px;
    padding: 2.5px 0;
    line-height: 23px;
    text-align: center;
    margin-left: auto;
  }
  .seatsApp .seats-list .bay-number .bay:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .seatsApp .seats-list .bay-number .bay:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .seatsApp .seats-list .seatsAll{
    width:92%;
    margin:0 auto;
    overflow: auto;
    scrollbar-width: none;
  }
  .seatsApp .seats-list ul{
    width:640px;
    min-height: 200px;
    text-algin:center
  }
  .seatsApp .seats-list ul li{
    display: flex;
    justify-content: center;
  }
  .seatsApp .seats-list ul li span{
    width:22px;
    height:22px;
    border:solid 1px #ccc;
    border-radius:9px;
    flex-shrink: 0;
    box-sizing: border-box;
    margin: 3px 3px;
    background:#fff
  }
  .seatsApp .seats-list ul li span.W{
    background:#eee
  }
  .seatsApp .seats-list ul li span.N{
    background:#fff
  }
  .seatsApp .seats-list ul li span.LK{
    background:#FFB900;
    border-color:#FFB900;
  }

  .seatsApp .seats-list ul li span.choose{
    border-color:#E9145A;
    background:#E9145A
  }

  .seatsApp .showInfo{
    width:96%;
    margin:0 auto;
    background:#fff;
    border-radius:6px;
    margin-bottom:15px
  }
  .seatsApp .showInfo h2{
    font-size:18px;
    font-weight:bold;
    color:#333;
    padding:10px
  }
  .seatsApp .showInfo p{
    font-size:14px;
    color:#666;
    padding:0 10px 10px 10px
  }
  .seatsApp .showInfo dl{
    display: grid;
    grid-template-columns: 30.5% 30.5% 30.5% ;/*有几列，每列有多大*/
    grid-gap: 10px;
    margin-left:10px;
    padding-bottom:10px
  }
  .seatsApp .showInfo dl dd{
    background:#ececec;
    width:100%;
    position: relative;
    border-radius:6px;
  }
  .seatsApp .showInfo dl dd span{
    display:block;
    padding:10px 0 0 10px;
    font-size:16px;
    font-weight:bold
  }
  .seatsApp .showInfo dl dd font{
    display:block;
    padding:2px 0 10px 10px;
    font-size:15px;
    color:#E9145A
  }
  .seatsApp .showInfo dl dd i{
    position: absolute;
    top:50%;
    right:4%;
    transform: translateY(-50%);
  }

  .seatsApp .btn{
    width:92%;
    margin:0 auto;
    height:45px;
    border-radius:45px;
    background: linear-gradient(90deg, #FE506A, #FE5CA3);
    text-align:center;
    line-height:45px;
    color:#fff;
    font-size:18px;
  }

  .seatsApp .txg{
    width:90%;
    margin:0 auto
  }
  .seatsApp .txg p{
    font-size:14px;
    line-height:24px;
    color:#666;
  }
  .seatsApp .txg p:first-child{
    text-indent: 0;
    color:#000
  }
</style>